import { React, useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Container, TextField, Button } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import api from './api';
import Header from './components/Header';
import { useConfirmBackLogout } from './common/useConfirmBackLogout';
import BackButton from './common/BackButton';
 
import { useNavigationHistory } from './common/navigationHistory';

const CorporateInfo = () => {
    const [corporates, setCorporates] = useState([]);
    const [filteredCorporates, setFilteredCorporates] = useState([]);
    const [searchName, setSearchName] = useState('');
    const [page, setPage] = useState(0);
        const itemsPerPage = 5;
    const navigate = useNavigate();
    const handleLogout = () => {
      localStorage.removeItem('user');
      sessionStorage.clear(); // ← これ追加！
      navigate('/login/host');
    };
     const [showFormMenu, setShowFormMenu] = useState(false);

    const [editTarget, setEditTarget] = useState(null);

    const fetchCorporates = async () => {
      try {
        const res = await api.get('/api/corporates');
        setCorporates(res.data); // もともと使ってるステート名に合わせて
        setFilteredCorporates(res.data); // 検索などに使ってるならこっちも
      } catch (err) {
        console.error('協力会社一覧の取得に失敗:', err);
      }
    };    

    const handleSaveEdit = async () => {
      try {
        await api.put(`/api/corporate/${editTarget.corporate_id}`, {
          company_name: editTarget.company_name,
          address: editTarget.address,
          phone_number: editTarget.phone_number,
          zip_code: editTarget.zip_code,
          email: editTarget.email,
        });
    
        alert('協力会社情報を更新しました');
        setEditTarget(null);
    
        fetchCorporates();
      } catch (err) {
        console.error('更新失敗:', err);
        alert('協力会社情報の更新に失敗しました');
      }
    };
    
    useEffect(() => {
        api.get('/api/corporates')
          .then(res => {
            setCorporates(res.data);
            setFilteredCorporates(res.data);
          })
          .catch(err => console.error('協力会社情報の取得失敗:', err));
      }, []);
      
    useEffect(() => {
      const filtered = corporates.filter(ct =>
        ct.company_name.includes(searchName)
      );
      setFilteredCorporates(filtered);
      setPage(0);
    }, [searchName, corporates]);

    useConfirmBackLogout(navigate);
    useNavigationHistory();
      

return <div>
          <Header
            title="メッセナゴヤ 協力会社情報"
          />
          <Container sx={{ mt: 5 }}>
            <Box sx={{ display: 'flex' }}>
              {/* 左メニュー */}
              <Box sx={{ width: '20%', pr: 2, borderRight: '1px solid #ccc' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Box className="menu-item" onClick={() => navigate('/host-dashboard')}>
                    申請状況
                  </Box>
                  <Box
                    className="menu-group"
                    id="hover-block"
                    onMouseEnter={() => {}}
                    onMouseLeave={() => {}}
                  >
                    <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                      会社情報
                    </Box>
                      {showFormMenu && (
                        <Box className="hover-menu">
                          <Typography
                            sx={{ color: '#0071bc', textAlign: 'center' }}
                            className='form-button'
                            onClick={() => navigate('/exhibitor-info')}
                          >
                            出展者
                          </Typography>
                          <Typography
                            sx={{ color: '#0071bc', textAlign: 'center' }}
                            className='form-button'
                            onClick={() => navigate('/corporate-info')}
                          >
                            協力会社
                          </Typography>
                        </Box>
                      )}
                  </Box>
                  <Box className="menu-item" onClick={() => navigate('/create-mail')}>
                    メール作成
                  </Box>
                  <Box className="menu-item" onClick={() => navigate('/create-notice')}>
                    お知らせ作成
                  </Box>
                  <Box className="menu-item" onClick={() => navigate('/form-history')}>
                    再提出ログ確認
                  </Box>
                </Box>
                <BackButton />
              </Box>
  
              {/* メインコンテンツ（右） */}
              <Box sx={{ width: '80%', pl: 2 }}>
                <Typography variant="h6" gutterBottom className='title'>協力会社情報検索</Typography>
                <TextField
                label="会社名で検索"
                variant="outlined"
                fullWidth
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
                sx={{ mb: 2 , mt: 3 }}
                />
                <TableContainer component={Box}>
                <Table>
                    <TableHead>
                    <TableRow>
                        <TableCell>会社名</TableCell>
                        <TableCell>郵便番号</TableCell>
                        <TableCell>住所</TableCell>
                        <TableCell>電話番号</TableCell>
                        <TableCell>メールアドレス</TableCell>
                        {/* <TableCell>操作</TableCell> */}
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {filteredCorporates
                      .slice(page * itemsPerPage, (page + 1) * itemsPerPage)
                      .map((ct, index) => (
                        <TableRow key={index}>
                          <TableCell>{ct.company_name}</TableCell>
                          <TableCell>{ct.zip_code}</TableCell>
                          <TableCell>{ct.address}</TableCell>
                          <TableCell>{ct.phone_number}</TableCell>
                          <TableCell>{ct.email}</TableCell>
                          {/* <TableCell>
                            <Button variant="outlined" onClick={() => {console.log(ct);  setEditTarget(ct);}}>
                              編集
                            </Button>
                          </TableCell> */}
                        </TableRow>
                      ))}
                    </TableBody>
                </Table>
                </TableContainer>
                {editTarget && (
                  <Box sx={{ mt: 4, p: 2, border: '1px solid #ccc', borderRadius: '8px' }}>
                    <Typography variant="h6">出展者情報の編集</Typography>
                    <TextField
                      label="会社名"
                      fullWidth
                      value={editTarget.company_name}
                      onChange={(e) =>
                        setEditTarget({ ...editTarget, company_name: e.target.value })
                      }
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      label="住所"
                      fullWidth
                      value={editTarget.address}
                      onChange={(e) =>
                        setEditTarget({ ...editTarget, address: e.target.value })
                      }
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      label="電話番号"
                      fullWidth
                      value={editTarget.phone_number}
                      onChange={(e) =>
                        setEditTarget({ ...editTarget, phone_number: e.target.value })
                      }
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      label="郵便番号"
                      fullWidth
                      value={editTarget.zip_code}
                      onChange={(e) =>
                        setEditTarget({ ...editTarget, zip_code: e.target.value })
                      }
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      label="メールアドレス"
                      fullWidth
                      value={editTarget.email}
                      onChange={(e) =>
                        setEditTarget({ ...editTarget, email: e.target.value })
                      }
                      sx={{ mb: 2 }}
                    />
                    <Button variant="contained" onClick={handleSaveEdit}>
                      保存する
                    </Button>
                    <Button variant="text" color="error" onClick={() => setEditTarget(null)} sx={{ ml: 2 }}>
                      キャンセル
                    </Button>
                  </Box>
                )}
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: 2 }}>
                  <Button
                   variant="outlined"
                   disabled={page === 0}
                   onClick={() => setPage(page - 1)}
                  >
                   前へ
                  </Button>
                  <Button
                   variant="outlined"
                   disabled={(page + 1) * itemsPerPage >= filteredCorporates.length}
                   onClick={() => setPage(page + 1)}
                  >
                   次へ
                  </Button>
                </Box>
              </Box>
            </Box>
          </Container>
          <footer>
            <Typography>
              © 2026 THE MID-JAPAN ECONOMIST.
            </Typography>
          </footer>
        </div>;
};
export default CorporateInfo;
